var _linearGradient, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3.4,
    x2: 60.6,
    y1: 32,
    y2: 32
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bb4f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2191e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007edb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_95",
    "data-name": "Layer 95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 3.4a28.59 28.59 0 0 0 -28.6 28.6 28.59 28.59 0 0 0 28.6 28.6 28.59 28.59 0 0 0 28.6-28.6 28.59 28.59 0 0 0 -28.6-28.6zm20.6 43.17a.6.6 0 0 1 -.6.6h-8.57a.6.6 0 0 1 -.6-.6v-12.86a.6.6 0 0 1 .6-.6h3.68v-5.11a1.54 1.54 0 0 0 -1.54-1.54h-13v6.65h3.69a.6.6 0 0 1 .6.6v12.86a.6.6 0 0 1 -.6.6h-8.55a.6.6 0 0 1 -.6-.6v-12.86a.6.6 0 0 1 .6-.6h3.69v-6.65h-13a1.54 1.54 0 0 0 -1.51 1.54v5.11h3.68a.6.6 0 0 1 .6.6v12.86a.6.6 0 0 1 -.6.6h-8.57a.6.6 0 0 1 -.6-.6v-12.86a.6.6 0 0 1 .6-.6h3.69v-5.11a2.74 2.74 0 0 1 2.74-2.74h13v-6.66h-3.72a.6.6 0 0 1 -.6-.6v-8.57a.6.6 0 0 1 .6-.6h8.58a.6.6 0 0 1 .6.6v8.57a.6.6 0 0 1 -.6.6h-3.69v6.66h13a2.74 2.74 0 0 1 2.71 2.74v5.11h3.69a.6.6 0 0 1 .6.6z",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.e421cd4afc457a6ad869d9139c29908b.svg";
export { ForwardRef as ReactComponent };